import * as React from 'react';
import {Link} from "react-router-dom";
import {Main} from "../components/Main";
import {Box} from "../components/sharedComponents/Box";
import {notify} from "../utilities/notify";
import Services from "../utilities/Services";
import {FormField, RequiredLegend, focusFirstInvalid, WYMAGANIA_HASLA} from "../components/sharedComponents/Forms";
interface MatchParams {
    path: string;
}
export interface RouteComponentProps<MatchParams> {
    match: any;
    history: any;
}
interface Props extends RouteComponentProps<MatchParams> {
}
export class NewPasswordOld extends React.Component<Props> {
    formularz = React.createRef<HTMLFormElement>();
    naglowekSukcesu = React.createRef<HTMLHeadingElement>();

    state={
        zmianaSuccess: false,
        bladHasla: '',
        bladPowtorzenia: '',
        newPassword: '',
        repNewPassword: '',
        token: ''
    };
    componentDidMount() {
        let {match} = this.props;
        if (match)
            if (match.params)
                if (match.params.token)
                {
                    this.setState({token: match.params.token});
                    //this.sprawdzAktywacje(match.params.id);
                }
    }
    componentDidUpdate(_prevProps: any, prevState: any) {
        if (!prevState.zmianaSuccess && this.state.zmianaSuccess && this.naglowekSukcesu.current) {
            this.naglowekSukcesu.current.focus();
        }
    }

    onChangePas = (e: any) => {
        this.setState({newPassword: e.target.value, bladHasla: ''});
    }

    onChangeRepPas = (e: any) => {
        this.setState({repNewPassword: e.target.value, bladPowtorzenia: ''});
    }

    onZapiszHaslo = (e: React.FormEvent<any>) => {
        e.preventDefault()
        let {newPassword, repNewPassword} = this.state;

        if ((newPassword === repNewPassword) && (newPassword.length > 0)) {
            this.setState({bladHasla: '', bladPowtorzenia: ''});
            Services.SprawdzHaslo(newPassword).then((response) => {
                if (response.status === 200) {
                    this.zapiszNoweHaslo(this.state.token, this.state.newPassword);
                }
            }).catch((error) => {
                const komunikat = (error.response && error.response.data.message) || 'Hasło nie spełnia wymagań.';
                this.setState({bladHasla: komunikat}, () => focusFirstInvalid(this.formularz.current));
                notify.error(komunikat, 'Błąd zmiany hasła');
            })
        } else {
            this.setState({bladPowtorzenia: 'Hasła nie są identyczne.'}, () => focusFirstInvalid(this.formularz.current));
            notify.error('Sprawdź poprawność haseł', 'Błąd zapisu');
        }
    }

    zapiszNoweHaslo = (token: string, haslo: string) => {
        Services.ZmianaHaslaResetOld(token, haslo)
            .then((response) => {
                if (response.status === 200) {
                    //this.setState({onRegister: true, registerLoading: false})
                    console.log("Zapis nowego hasla ok");
                    this.setState({zmianaSuccess: true});
                }
            }).catch((error) => {
            //this.setState({registerLoading: false})
            //alert(error.response.data.message);
            console.log('Zapis nowego hasla error');
        })
    }
    render() {
        let {zmianaSuccess, bladHasla, bladPowtorzenia} = this.state;
        return( <Main active={'LOGIN'} title={'Ustaw nowe hasło'}>
                <Box>
                    {(!zmianaSuccess)?
                        <>
                        <h1 className={'h3'}>Ustaw nowe hasło</h1>
                        <p>Wprowadź nowe hasło aby przywrócić dostęp do konta.</p>
                        <form onSubmit={this.onZapiszHaslo} ref={this.formularz}>
                            <section className={'register-form'}>
                                <RequiredLegend/>
                                <div className={'row'}>
                                    <FormField label={'Nowe hasło:'} required hint={WYMAGANIA_HASLA} error={bladHasla || null}>
                                        <input type={'password'} className={'form-control'} autoComplete={'new-password'}
                                               onChange={this.onChangePas}/>
                                    </FormField>
                                    <FormField label={'Powtórz hasło:'} required error={bladPowtorzenia || null}>
                                        <input type={'password'} className={'form-control'} autoComplete={'new-password'}
                                               onChange={this.onChangeRepPas}/>
                                    </FormField>
                                </div>
                            </section>
                            <div className={'buttons-line'}>
                                <button type={'submit'} className={'btn btn-custom-secondary'}>Zapisz hasło</button>
                            </div>
                        </form>
                        </>
                        :
                        <>
                            <h1 className={'h3'} style={{color: 'green'}} ref={this.naglowekSukcesu} tabIndex={-1}><i className="fa fa-check" style={{color: 'green'}} aria-hidden={'true'}/> Hasło zostało zapisane</h1>
                            <p>Hasło do twojego konta zostało poprawnie zmienione. Możesz teraz zalogować się do twojego konta.</p>
                            <Link to={'/login'}><span className={'password-lost'} style={{color: '#E20214'}}>Przejdź do logowania</span></Link>
                        </>
                    }
                </Box>
            </Main>
        );
    }
}
export default NewPasswordOld
